import { WidgetProps } from '@rjsf/core';
import { useState, useEffect } from 'react';

const RichTextEditableWidget = (props: WidgetProps) => {
  const [value, setValue] = useState(props.value || 'Click to edit...');

  useEffect(() => {
    setValue(props.value || 'Click to edit...');
  }, [props.value]);

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = event.target.value;
    setValue(newValue);
    props.onChange(newValue);
  };

  return (
    <div className="rich-text-editable-widget">
      <label>{props.schema.title}</label>
      <div style={{ 
        border: '1px solid #ccc', 
        borderRadius: '4px', 
        padding: '8px',
        backgroundColor: '#f9f9f9',
        fontSize: '14px',
        marginTop: '8px'
      }}>
        <p style={{ margin: '0 0 8px 0', fontWeight: 'bold' }}>
          Rich Text Editable
        </p>
        <p style={{ margin: '0 0 8px 0', fontSize: '12px', color: '#666' }}>
          Click on content to edit inline with rich text formatting. Sidebar stays narrow.
        </p>
        <textarea
          value={value}
          onChange={handleChange}
          placeholder="Edit content here or click on content in template view..."
          rows={4}
          style={{
            width: '100%',
            padding: '8px',
            border: '1px solid #ddd',
            borderRadius: '4px',
            fontSize: '14px',
            fontFamily: 'inherit',
            resize: 'vertical'
          }}
        />
        <div style={{ 
          marginTop: '8px', 
          fontSize: '12px', 
          color: '#666',
          fontStyle: 'italic' 
        }}>
          Changes save when you click outside the editor.
        </div>
      </div>
    </div>
  );
};

export default RichTextEditableWidget;